/** @format */

export default {
	SET_DISPUTE: 'SET_DISPUTE',
	SET_ERROR_FOR_DISPUTE: 'SET_ERROR_FOR_DISPUTE',
	SET_DISPUTES: 'SET_DISPUTES',
	SET_DISPUTES_SUMMARY: 'SET_DISPUTES_SUMMARY',
};
